export const SHOW_TOAST = "SHOW_TOAST";
export const RESET_TOAST = "RESET_TOAST";


// WEBPACK FOOTER //
// ./utils/simpleFetchActionTypes.js